import { ReactNode } from "react";
import FixaCheckbox from "@coworker/apprestructured/src/shared/wrappers/FixaCheckbox/FixaCheckbox";
import styles from "./SelectableTaskCardWrapper.module.css";

interface SelectableTaskCardWrapperProps {
  children: ReactNode;
  value: string;
  selected: boolean;
  onCardClick: (value: string) => void;
  onCheckboxSelect: (value: string) => void;
}

export const SelectableTaskCardWrapper = ({
  children,
  value,
  selected,
  onCardClick,
  onCheckboxSelect,
}: SelectableTaskCardWrapperProps) => {
  return (
    <div className={styles["wrapper"]}>
      <FixaCheckbox
        id={`select-task-${value}`}
        value="select-task"
        checked={selected}
        onChange={() => onCheckboxSelect(value)}
      />
      <div
        className={styles["cardContent"]}
        onClick={() => onCardClick(value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onCardClick(value);
          }
        }}
        role="button"
        tabIndex={0}
      >
        {children}
      </div>
    </div>
  );
};
